const numberFormat = new Intl.NumberFormat('ru-RU')
const dateFormat = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', year: 'numeric' })

export const countLabel = (value: number) => numberFormat.format(value)

/** Цены приходят в копейках: делим один раз здесь, чтобы в разметке не было арифметики. */
export const priceLabel = (kopecks: number | null) =>
  kopecks === null ? null : `${numberFormat.format(kopecks / 100)} ₽`

export const dateLabel = (value: string | null) => (value ? dateFormat.format(new Date(value)) : null)

export const fileSizeLabel = (bytes: number) => `${Math.max(Math.round(bytes / 1024), 1)} КБ`
